import angular from "angular";

angular
    .module('app')
    .component('lessonFormMain', {
        template: require('./lesson-form-main.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$sce', 'Upload', '$scope', 'notify', '$uibModal', '$timeout', '$rootScope', controller],
        bindings: {
            lesson: '<',
            course: '<',
        }
    });

function controller($http, ErrorResponseParser, Notifier, $sce, Upload, $scope, notify, $uibModal, $timeout, $rootScope) {

    let $ctrl = this;

    $ctrl.uploadFiles = [];

    $ctrl.$onInit = function () {
        $ctrl.getData();
    };

    $ctrl.getData = function () {
        $http
            .get(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/get-data`)
            .then(
                res => {
                    $ctrl.title = res.data.title;
                    $ctrl.data = res.data.data;
                    $timeout(() => {
                        Array.from(document.querySelectorAll('.js-player')).map(p => new Plyr(p));
                    }, 500);
                },
                err => {

                }
            );
    };

    $ctrl.save = function () {

        let data = [];

        $ctrl.data.forEach(function (item) {
            if (item.type == 'text') {
                data.push(item);
            }
            if (item.type == 'image') {
                data.push(item);
            }
            if (item.type == 'audio') {
                data.push(item);
            }
            if (item.type == 'video') {
                item.video_id = item.video.id;
                data.push(item);
            }
            if (item.type == 'vimeo' || item.type == 'youtube' || item.type == 'boomstream' || item.type == 'boomstream-live') {
                data.push(item);
            }
        });

        $ctrl.loading = true;

        Upload.upload({
            url: `/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}`,
            data: {
                _method: 'PUT',
                title: $ctrl.title,
                data: data,
            }
        }).then(
            function (response) {
                $ctrl.lesson.title = $ctrl.title;
                $ctrl.loading = false;
                Notifier.success('Данные успешно сохранены', 2);
                $rootScope.$emit('LessonUpdated', {
                    lesson_id: $ctrl.lesson.id,
                    title: $ctrl.title
                });
            },
            function (error) {
                Notifier.error(error.message, 2);
                $ctrl.loading = false;
            }
        );

    };

    $ctrl.addText = function () {
        $ctrl.data.push({
            type: 'text',
            content: null
        });
    };

    $ctrl.upItem = function (ind) {
        if (ind > 0) {
            let t = $ctrl.data[ind - 1];
            $ctrl.data[ind - 1] = $ctrl.data[ind];
            $ctrl.data[ind] = t;
        }
    };

    $ctrl.downItem = function (ind) {
        if (ind < $ctrl.data.length - 1) {
            let t = $ctrl.data[ind + 1];
            $ctrl.data[ind + 1] = $ctrl.data[ind];
            $ctrl.data[ind] = t;
        }
    };

    $ctrl.addVimeoVideo = function () {
        $uibModal
            .open({
                component: 'vimeoVideoModal',
                size: 'md',
                resolve: {
                    lesson: function () {
                        return $ctrl.lesson;
                    },
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (video) {

                    $ctrl.data.push({
                        type: 'vimeo',
                        html: video.html,
                        link: video.link
                    });
                },
                function () {

                }
            )
    };

    $ctrl.addYouTube = function () {
        $uibModal
            .open({
                component: 'youTubeModal',
                size: 'md',
                resolve: {
                    lesson: function () {
                        return $ctrl.lesson;
                    },
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (video) {

                    $ctrl.data.push({
                        type: 'youtube',
                        html: video.html,
                        link: video.link,
                        code: video.code,
                        id: 'youtube',
                    });

                    $timeout(() => {
                        Array.from(document.querySelectorAll('.js-player')).map(p => new Plyr(p));
                    }, 2000);
                },
                function () {

                }
            )
    };

    $ctrl.addBoomStream = () => {
        $uibModal.open({
            component: 'boomStreamModal',
            size: 'md',
            resolve: {
                lesson: function () {
                    return $ctrl.lesson;
                },
                course: function () {
                    return $ctrl.course;
                }
            }
        }).result.then(function (video) {
            $ctrl.data.push({
                type: 'boomstream',
                html: video.html,
                link: video.link,
            });
        }, function () {

        })
    }

    $ctrl.addBoomStreamLive = () => {
        $uibModal.open({
            component: 'boomStreamLiveModal',
            size: 'md',
            resolve: {
                lesson: function () {
                    return $ctrl.lesson;
                },
                course: function () {
                    return $ctrl.course;
                }
            }
        }).result.then(function (video) {
            $ctrl.data.push({
                type: 'boomstream-live',
                html: video.html,
                link: video.link,
            });
        }, function () {

        })
    }

    $ctrl.selectVideoModal = function () {
        $uibModal
            .open({
                component: 'videoSelectModal',
                size: 'lg',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    let video = result;
                    $ctrl.data.push({
                        type: 'video',
                        video: video,
                    });
                },
                function () {
                }
            )
    };

    $ctrl.selectImageModal = function () {
        $uibModal
            .open({
                component: 'uploadImage',
                size: 'md',
            })
            .result
            .then(
                function (result) {
                    $ctrl.data.push({
                        type: 'image',
                        image: result
                    });
                },
                function (err) {

                }
            )
    };

    $ctrl.selectAudioModal = function () {
        $uibModal
            .open({
                component: 'uploadAudio',
                size: 'md',
            })
            .result
            .then(
                function (result) {
                    $ctrl.data.push({
                        type: 'audio',
                        audio: result
                    });
                },
                function (err) {

                }
            )
    };

    $ctrl.removeDataItem = function (key) {
        if (confirm("Вы уверены?")) {
            $ctrl.data.splice(key, 1);
        }
    };

    $ctrl.trustHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $ctrl.deleteLessonModal = function (lesson) {
        $uibModal
            .open({
                component: 'deleteLessonModal',
                resolve: {
                    lesson: function () {
                        return $ctrl.lesson;
                    },
                    course: function () {
                        return $ctrl.course;
                    }
                },
                size: 'lg',
            })
            .result
            .then(
                function (result) {

                },
                function (err) {

                }
            )
        // if (confirm('Удалить ' + lesson.title + '?')) {
        //     $http.delete(`/admin/courses/${$ctrl.course.id}/lessons/${lesson.id}`).then(
        //         function (response) {
        //             Notifier.success('Урок успешно удален', 2);
        //             window.location = `/admin/courses/${$ctrl.course.id}/lessons`;
        //         },
        //         function () {
        //             Notifier.error('Произошла ошибка', 2)
        //         }
        //     );
        // }
    };
}
